import {TmcListDialog} from "./service/TmcListDialog";
import {tmcList, TmcList} from "./component/TmcListComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.dialog`;

    return angular.module(moduleName, [])
                  .component(TmcList, tmcList())
                  .service(TmcListDialog.id, TmcListDialog)
                  .name;
}
